import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1ff1b9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "camera_name" }
const _hoisted_3 = { class: "camera_content_wrap" }
const _hoisted_4 = { class: "content_title" }
const _hoisted_5 = { class: "content_content" }
const _hoisted_6 = { class: "camera_content_wrap" }
const _hoisted_7 = { class: "content_title" }
const _hoisted_8 = { class: "content_content" }
const _hoisted_9 = { class: "camera_content_wrap" }
const _hoisted_10 = { class: "content_title" }
const _hoisted_11 = { class: "content_content" }
const _hoisted_12 = { class: "camera_content_wrap" }
const _hoisted_13 = { class: "content_title" }
const _hoisted_14 = { class: "content_content" }
const _hoisted_15 = { class: "camera_content_wrap" }
const _hoisted_16 = { class: "content_title" }
const _hoisted_17 = { class: "content_content" }
const _hoisted_18 = { class: "camera_content_wrap" }
const _hoisted_19 = { class: "content_title" }
const _hoisted_20 = { class: "content_content" }
const _hoisted_21 = { class: "camera_content_wrap" }
const _hoisted_22 = { class: "content_title" }
const _hoisted_23 = { class: "content_content" }
const _hoisted_24 = { class: "camera_content_wrap" }
const _hoisted_25 = { class: "content_title" }
const _hoisted_26 = { class: "content_content ptz_content_wrap" }
const _hoisted_27 = { class: "ptz_content" }
const _hoisted_28 = { class: "ptz_content" }
const _hoisted_29 = { class: "ptz_content" }
const _hoisted_30 = { class: "camera_content_wrap" }
const _hoisted_31 = { class: "content_title" }
const _hoisted_32 = { class: "content_content monitoring_period_content_wrap" }
const _hoisted_33 = { class: "monitoring_period_content" }
const _hoisted_34 = { class: "monitoring_period_content" }
const _hoisted_35 = { class: "monitoring_period_content" }
const _hoisted_36 = { class: "camera_content_wrap" }
const _hoisted_37 = { class: "content_title" }
const _hoisted_38 = { class: "content_content storage_period_content_wrap" }
const _hoisted_39 = { class: "storage_period_content" }
const _hoisted_40 = {
  key: 0,
  class: "camera_content_wrap"
}
const _hoisted_41 = { class: "content_title" }
const _hoisted_42 = { class: "content_content storage_period_content_wrap" }
const _hoisted_43 = { class: "storage_period_content" }
const _hoisted_44 = {
  key: 1,
  class: "camera_content_wrap"
}
const _hoisted_45 = { class: "content_title" }
const _hoisted_46 = { class: "content_content storage_period_content_wrap" }
const _hoisted_47 = { class: "storage_period_content" }
const _hoisted_48 = { class: "camera_content_wrap" }
const _hoisted_49 = { class: "content_title" }
const _hoisted_50 = { class: "content_content" }

import DialogBase from '@/components/molecules/DialogBase'
import { zeroPadding } from '@/js/utils/filters'
import i18n from '@/plugins/i18n'
import { getRate } from '@/js/utils/cameraDetail'
import { getObjectDetectSettingStr } from '@/js/utils/objectDetect'
import { CameraDetail } from '@/@types/typescript-axios'
import { computed, withDefaults } from 'vue'

type PropsType = {
  cameraData: CameraDetail
  modelValue: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraDetailDialog',
  props: {
    cameraData: null,
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cameraData: CameraDetail, modelValue: boolean };





const internalValue = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    if (props.modelValue !== newVal) {
      emit('update:modelValue', newVal)
    }
  },
})

const frameRate = computed<string>(() => getRate(props.cameraData))
const timeHoli = computed<string>(() =>
  periodMsg(props.cameraData.timeHoliFrom, props.cameraData.timeHoliTo)
)
const timeSat = computed<string>(() =>
  periodMsg(props.cameraData.timeSatFrom, props.cameraData.timeSatTo)
)
const timeWeek = computed<string>(() =>
  periodMsg(props.cameraData.timeWeekFrom, props.cameraData.timeWeekTo)
)
const pan = computed<string>(() => (props.cameraData.can_pan ? '○' : '×'))
const tilt = computed<string>(() => (props.cameraData.can_tilt ? '○' : '×'))
const zoom = computed<string>(() => (props.cameraData.can_zoom ? '○' : '×'))
const note = computed<string>(() => {
  if (props.cameraData.note === '') {
    return i18n.global.t('camera_detail_dialog.none')
  }
  return props.cameraData.note
})

const uploadOption = computed<string>(() => {
  if (props.cameraData.archive_hide && props.cameraData.archive_hide.includes('no_motion')) {
    return i18n.global.t('camera_detail_dialog.motion_detection_only')
  } else {
    return i18n.global.t('camera_detail_dialog.all')
  }
})
/**
 * 物体検知設定
 * @return {String} 物体検知設定の文字列
 */
const motionDetectObjects = computed<string>(() =>
  getObjectDetectSettingStr(props.cameraData.motion_detect_objects)
)
/**
 * 物体検知設定の有無
 * @return {Boolean} 物体検知設定がある場合true
 */
const hasMotionDetectObjects = computed<boolean>(
  () => props.cameraData.motion_detect_objects && props.cameraData.motion_detect_objects.length > 0
)
/**
 * 画像マスク設定
 * @return {String} 画像マスク設定の文字列
 */
const imageMaskObjects = computed<string>(() =>
  getObjectDetectSettingStr(props.cameraData.image_mask_objects)
)
/**
 * 画像マスク設定の有無
 * @return {Boolean} 画像マスク設定がある場合true
 */
const hasImageMaskObjects = computed<boolean>(
  () => props.cameraData.image_mask_objects && props.cameraData.image_mask_objects.length > 0
)

const close = () => {
  internalValue.value = false
}

const periodMsg = (fromMinute: number, toMinute: number) => {
  let msg = ''
  if (fromMinute === 0 && toMinute === 1440) {
    msg = i18n.global.t('camera_detail_dialog.all_day_possible')
  } else if (fromMinute === 0 && toMinute === 0) {
    msg = i18n.global.t('camera_detail_dialog.all_day_impossible')
  } else {
    const timeFrom = convertMinutesToTime(fromMinute)
    const timeTo = convertMinutesToTime(toMinute)
    msg = timeFrom + '-' + timeTo
  }
  return msg
}
const convertMinutesToTime = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  minutes = minutes % 60
  return zeroPadding(hours, 2) + ':' + zeroPadding(minutes, 2)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    useCancelBtn: false,
    onApprove: close
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('camera_detail_dialog.camera_information')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.cameraData.camera_name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('camera_detail_dialog.company')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.cameraData.customer_name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('camera_detail_dialog.place')), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.cameraData.location_name), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('camera_detail_dialog.location')), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(__props.cameraData.location_address), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('camera_detail_dialog.product')), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(__props.cameraData.product_name), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('camera_detail_dialog.resolution')), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(__props.cameraData.image_rs_width) + " x " + _toDisplayString(__props.cameraData.image_rs_height), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('camera_detail_dialog.upload')), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(uploadOption)), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('camera_detail_dialog.rate')), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(frameRate)), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('camera_detail_dialog.ptz_operation')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('camera_detail_dialog.move_horizontally')) + " : " + _toDisplayString(_unref(pan)), 1),
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('camera_detail_dialog.move_vertically')) + " : " + _toDisplayString(_unref(tilt)), 1),
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('camera_detail_dialog.scale')) + " : " + _toDisplayString(_unref(zoom)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('camera_detail_dialog.surveillance_time')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('camera_detail_dialog.weekday')) + ":" + _toDisplayString(_unref(timeWeek)), 1),
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('camera_detail_dialog.sat')) + ":" + _toDisplayString(_unref(timeSat)), 1),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('camera_detail_dialog.holiday')) + ":" + _toDisplayString(_unref(timeHoli)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('camera_detail_dialog.storage_period')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, _toDisplayString(__props.cameraData.archive_storing_days) + " " + _toDisplayString(_ctx.$t('camera_detail_dialog.days_ago_or_later')), 1)
          ])
        ]),
        (_unref(hasMotionDetectObjects))
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('camera_detail_dialog.object_detection')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(motionDetectObjects)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(hasImageMaskObjects))
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('camera_detail_dialog.image_mask')), 1),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(imageMaskObjects)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('camera_detail_dialog.remarks')), 1),
          _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(note)), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})